export default "__VITE_ASSET__F_Hjvhjo__"